import { render, staticRenderFns } from "./AssessmentCourses.vue?vue&type=template&id=7bc30f3b"
import script from "./AssessmentCourses.vue?vue&type=script&lang=js"
export * from "./AssessmentCourses.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCourses.vue?vue&type=style&index=0&id=7bc30f3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports